import { useEffect, useState } from "react";
import { adminApi } from "@/admin/api";

export default function Activity() {
  const [rows, setRows] = useState([]);
  useEffect(() => { adminApi.get("/admin/audit").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-5">
      <h1 className="text-xl font-bold text-gray-900">Activity Log</h1>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500">
            <tr><th className="p-3">Date</th><th className="p-3">Admin</th><th className="p-3">Action</th><th className="p-3">Detail</th><th className="p-3">IP</th></tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id} className="border-t border-gray-100">
                <td className="p-3 text-xs text-gray-500">{new Date(a.created_at).toLocaleString("en-IN")}</td>
                <td className="p-3">{a.admin_email}</td>
                <td className="p-3 capitalize">{a.action.replace(/_/g, " ")}</td>
                <td className="p-3 text-gray-500">{a.detail || "—"}</td>
                <td className="p-3 text-xs text-gray-400">{a.ip || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-gray-400">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
